<div class="wizard-integration-list-item">
  <nb-accordion>
    <nb-accordion-item #item>
      <nb-accordion-item-header>
        <i
          class="fas fa-chevron-right wizard-integration-list-item-arrow-icon"
          [ngStyle]="{
            transition: 'transform 0.3s ease-in-out',
            transform: item?.expanded ? 'rotate(90deg)' : 'rotate(0deg)'
          }"
          style="font-size: 14px"
        ></i>
        <div class="wizard-integration-list-item-header-container">
          <label
            style="
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin: auto 0px;
            "
            >{{ integration?.value?.friendlyNameDisplayed|| integration?.value?.name||'' }}</label
          >
          <div style="width: 323px">
            <label style="display: flex; align-items: center; gap: 5px">
              {{ "status" | translation }}:
              <ng-container
                *ngIf="
                  integration?.get('status')?.value === 'ok' ||
                  !integration?.get('status')?.value
                "
              >
                <i
                  class="fa-solid fa-circle-check wizard-success-icon"
                  [title]="integration?.get('message')?.value || 'Unknown'"
                ></i>
                <span class="wizard-success-label wizard-lowercase-label">{{
                  "complete" | translation
                }}</span>
              </ng-container>
              <ng-container
                *ngIf="integration?.get('status').value === 'error'"
              >
                <i
                  class="fa-solid fa-circle-x wizard-error-icon"
                  [title]="integration?.get('message').value || 'Unknown'"
                ></i>
                <span class="wizard-error-label wizard-lowercase-label">{{
                  "error" | translation
                }}</span>
              </ng-container>
              <ng-container
                *ngIf="integration?.get('status').value === 'processing'"
              >
                <i
                  class="fa-solid fa-loader fa-spin wizard-process-icon"
                  [title]="integration?.get('message')?.value || 'Unknown'"
                ></i>
                <span class="wizard-process-label wizard-lowercase-label">{{
                  "processing" | translation
                }}</span>
              </ng-container>
            </label>
          </div>
        </div>
      </nb-accordion-item-header>
      <nb-accordion-item-body>
        <ng-container [formGroup]="integration">
          <div class="wizard-input-container-form-fields-container">
            <nb-form-field>
              <label>{{ "integration_url" | translation }}</label>
              <ng-container
                *ngIf="
                  (this.integration?.get('url').invalid &&
                    this.integration?.get('url').dirty) ||
                  this.integration?.get('url')?.touched
                "
              >
              </ng-container>

              <input
                [placeholder]="'url' | translation"
                style="max-width: 100%"
                formControlName="url"
                nbInput
                [ngClass]="
                  this.integration?.get('url')?.pristine
                    ? ''
                    : this.integration?.get('url')?.valid
                    ? 'wizard-input-valid'
                    : 'wizard-input-invalid'
                "
              />
              <div
                class="wizard-input-container-form-field-label-error-wrapper"
              >
                <span
                  class="wizard-input-container-form-field-label-error"
                  *ngIf="
                    this.integration?.get('url')?.dirty &&
                    this.integration?.get('url')?.errors?.required
                  "
                >
                  <i class="fa-solid fa-triangle-exclamation"></i>
                  {{ "required" | translation }}
                </span>
                <span
                  class="wizard-input-container-form-field-label-error"
                  *ngIf="
                    this.integration?.get('url')?.dirty &&
                    this.integration?.get('url')?.errors?.pattern &&
                    !this.integration?.get('url')?.errors?.required
                  "
                >
                  <i class="fa-solid fa-triangle-exclamation"></i>

                  {{ "must_be_a_valid_url" | translation }}
                </span>
              </div>
            </nb-form-field>
            <nb-form-field>
              <label>{{ "friendly_name" | translation }}</label>
              <input
                [placeholder]="'friendly_name' | translation"
                style="max-width: 100%"
                formControlName="friendly_name"
                nbInput
                [ngClass]="
                  this.integration?.get('friendly_name').pristine
                    ? ''
                    : this.integration?.get('friendly_name')?.valid
                    ? 'wizard-input-valid'
                    : 'wizard-input-invalid'
                "
              />
              <div
                class="wizard-input-container-form-field-label-error-wrapper"
              >
                <span
                  class="wizard-input-container-form-field-label-error"
                  *ngIf="
                    this.integration?.get('friendly_name')?.dirty &&
                    this.integration?.get('friendly_name')?.errors?.required
                  "
                >
                  <i class="fa-solid fa-triangle-exclamation"></i>

                  {{ "required" | translation }}
                </span>
              </div>
            </nb-form-field>
          </div>

          <div class="wizard-input-container-form-fields-container">
            <nb-form-field autocomplete="off">
              <label>{{ "utility_account_username" | translation }}</label>
              <input
                [placeholder]="'username' | translation"
                style="max-width: 100%"
                formControlName="utilUsername"
                nbInput
                [ngClass]="
                  this.integration?.get('utilUsername').pristine
                    ? ''
                    : this.integration?.get('utilUsername')?.valid
                    ? 'wizard-input-valid'
                    : 'wizard-input-invalid'
                "
              />
              <div
                class="wizard-input-container-form-field-label-error-wrapper"
              >
                <span
                  class="wizard-input-container-form-field-label-error"
                  *ngIf="
                    this.integration?.get('utilUsername')?.dirty &&
                    this.integration?.get('utilUsername')?.errors?.required
                  "
                >
                  <i class="fa-solid fa-triangle-exclamation"></i>

                  {{ "required" | translation }}
                </span>
              </div>
            </nb-form-field>

            <nb-form-field>
              <label>{{ "utility_account_password" | translation }}</label>
              <input
                [placeholder]="'password' | translation"
                style="max-width: 100%"
                formControlName="utilPassword"
                type="password"
                nbInput
                [ngClass]="
                  this.integration?.get('utilPassword').pristine
                    ? ''
                    : this.integration?.get('utilPassword')?.valid
                    ? 'wizard-input-valid'
                    : 'wizard-input-invalid'
                "
              />

              <div
                class="wizard-input-container-form-field-label-error-wrapper"
              >
                <span
                  class="wizard-input-container-form-field-label-error"
                  *ngIf="
                    this.integration?.get('utilPassword')?.dirty &&
                    this.integration?.get('utilPassword')?.errors?.required
                  "
                >
                  <i class="fa-solid fa-triangle-exclamation"></i>

                  {{ "required" | translation }}
                </span>
              </div>
            </nb-form-field>
          </div>

          <div class="wizard-input-container-form-fields-container">
            <div class="wizard-integration-list-item-status-container">
              <label
                >{{ "tokens" | translation }}:
                <ng-container
                  *ngIf="
                    integration?.get('tokensProcess')?.value?.status === 'ok'
                  "
                >
                  <i
                    class="fa-solid fa-circle-check wizard-success-icon"
                    [title]="
                      integration?.get('tokensProcess')?.value?.message ||
                      'Unknown'
                    "
                  ></i>
                  <span class="wizard-success-label wizard-lowercase-label">{{
                    "complete" | translation
                  }}</span>
                </ng-container>
                <ng-container
                  *ngIf="
                    integration?.get('tokensProcess')?.value?.status === 'error'
                  "
                >
                  <i
                    class="fa-solid fa-circle-x wizard-error-icon"
                    [title]="
                      integration?.get('tokensProcess')?.value?.message ||
                      'Unknown'
                    "
                  ></i>
                  <span class="wizard-error-label wizard-lowercase-label">{{
                    "error" | translation
                  }}</span>
                </ng-container>
                <ng-container
                  *ngIf="
                    integration?.get('tokensProcess')?.value?.status ===
                    'processing'
                  "
                >
                  <i
                    class="fa-solid fa-loader fa-spin wizard-process-icon"
                    [title]="
                      integration?.get('tokensProcess')?.value?.message ||
                      'Unknown'
                    "
                  ></i>
                  <span class="wizard-process-label wizard-lowercase-label">{{
                    "processing" | translation
                  }}</span>
                </ng-container>
              </label>
              <p
                class="wizard-content"
                *ngIf="
                  integration?.get('tokensProcess')?.value?.status === 'error'
                "
              >
                {{ integration?.get("tokensProcess")?.value?.message }}
              </p>
            </div>

            <div class="wizard-integration-list-item-status-container">
              <label
                >{{ "terms" | translation }}:
                <ng-container
                  *ngIf="
                    integration?.get('termsProcess')?.value?.status === 'ok'
                  "
                >
                  <i
                    class="fa-solid fa-circle-check wizard-success-icon"
                    [title]="
                      integration?.get('termsProcess')?.value?.message ||
                      'Unknown'
                    "
                  ></i>
                  <span class="wizard-success-label wizard-lowercase-label">{{
                    "complete" | translation
                  }}</span>
                </ng-container>
                <ng-container
                  *ngIf="
                    integration?.get('termsProcess')?.value?.status === 'error'
                  "
                >
                  <i
                    class="fa-solid fa-circle-x wizard-error-icon"
                    [title]="
                      integration?.get('termsProcess')?.value?.message ||
                      'Unknown'
                    "
                  ></i>
                  <span class="wizard-error-label wizard-lowercase-label">{{
                    "error" | translation
                  }}</span>
                </ng-container>
                <ng-container
                  *ngIf="
                    integration?.get('termsProcess')?.value?.status ===
                    'processing'
                  "
                >
                  <i
                    class="fa-solid fa-loader fa-spin wizard-process-icon"
                    [title]="
                      integration?.get('termsProcess')?.value?.message ||
                      'Unknown'
                    "
                  ></i>
                  <span class="wizard-process-label wizard-lowercase-label">{{
                    "processing" | translation
                  }}</span>
                </ng-container>
              </label>
              <p
                class="wizard-content"
                *ngIf="
                  integration?.get('termsProcess')?.value?.status === 'error'
                "
              >
                {{ integration?.get("termsProcess")?.value?.message }}
              </p>
            </div>
          </div>

          <div class="wizard-button-container">
            <button
              [disabled]="
                !integration?.valid ||
                integration?.get('isProcessing').value ||
                integration.pristine
              "
              nbButton
              ghost
              class="text-link-color"
              (click)="updateIntegration()"
            >
              <i
                class="fa-light fa-floppy-disk text-link-color"
                style="margin-right: 10px"
              ></i>

              {{ "update_integration" | translation }}
            </button>
          </div>
        </ng-container>
      </nb-accordion-item-body>
    </nb-accordion-item>
  </nb-accordion>
</div>
